import * as React from 'react';
// TODO: deep import is bad, fix importing from index
import Link from '@wix/thunderbolt-elements/components/Link';
import { formatClassNames } from '@wix/editor-elements-common-utils';
import type {
  ICollapsibleTextControllerProps,
  ExpandControlData,
  ExpandControlProps,
} from '../../CollapsibleText.types';
import { st, classes } from '../style/CollapsibleText.component.st.css';
import { ExpandModeValues, TestIds } from '../../constants';
import semanticClassNames from '../../CollapsibleText.semanticClassNames';

const buttonSemanticClassName = formatClassNames(semanticClassNames.button);

export type ExpandControlCompProps = ExpandControlData &
  ExpandControlProps &
  ICollapsibleTextControllerProps;

export const ExpandControl: React.FC<ExpandControlCompProps> = ({
  link,
  linkText,
  textDescription,
  expandMode,
  readMoreText,
  readLessText,
  isExpanded,
  setIsExpanded,
  reportBiOnExpandClick,
  reportBiOnLinkClick,
}) => {
  const onExpandClick = () => {
    setIsExpanded(!isExpanded);
    reportBiOnExpandClick(!isExpanded);
  };

  const onLinkClick = () => {
    reportBiOnLinkClick();
  };

  switch (expandMode) {
    case ExpandModeValues.Expand:
      return (
        <button
          className={st(classes['expand-control'], buttonSemanticClassName)}
          onClick={onExpandClick}
          aria-label={textDescription}
          data-testid={TestIds.viewer.expand_control}
          aria-expanded={isExpanded}
        >
          {isExpanded ? readLessText : readMoreText}
        </button>
      );
    case ExpandModeValues.Link:
      return (
        <Link
          {...link}
          onClick={onLinkClick}
          aria-label={textDescription}
          className={st(classes['expand-control'], buttonSemanticClassName)}
          dataTestId={TestIds.viewer.expand_control}
        >
          {linkText}
        </Link>
      );
    default:
      return null;
  }
};
